import { render, staticRenderFns } from "./MemberPermissions.vue?vue&type=template&id=c3cfa57e&"
import script from "./MemberPermissions.vue?vue&type=script&lang=js&"
export * from "./MemberPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports